// extracted by mini-css-extract-plugin
module.exports = {"commentsCustomScrollBar":"_64egd","groupPopoverCommentsInner":"xmiLf","noComments":"wKxWg","addCommentButton":"_7bxEV"};